import { MutationTree } from "vuex";
import { ProcessImplementationState, ProcessImplementation } from "./model";

const mutations: MutationTree<ProcessImplementationState> = {
  setProcessImplementations(state, processImplementations: ProcessImplementation[]) {
    state.processImplementations = processImplementations
  },
  addProcessImplementation(state, processImplementation: ProcessImplementation) {
    state.processImplementations.push(processImplementation)
  },
  updateProcessImplementation(state, processImplementation: ProcessImplementation) {
    const index = state.processImplementations.findIndex(c => c.id === processImplementation.id);
    if(index !== -1) {
      state.processImplementations.splice(index, 1, processImplementation);
    }
  },
  deleteProcessImplementation(state, id: string) {
    state.processImplementations = state.processImplementations.filter(processImplementation => processImplementation.id !== id)
  }
}

export default mutations;
